import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  center?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  center = true
}: SectionHeadingProps) {
  return <div className={center ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-166" data-mp="3f2wynq2tn7yt">
      {eyebrow && <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-167" data-mp="3k0fappc4y3b1">
          {eyebrow}
        </p>}
      <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl md:text-[2.75rem]" data-id="element-168" data-mp="gjgkexi3pio4">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-169" data-mp="1u0wrqdv9tcn">
          {subtitle}
        </p>}
    </div>;
}